const csvTemplate = `sku,is_active
AU.SC-SPMW1001,yes
AU.SC-SPDCCF1,no`;

export default csvTemplate;
